import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from '../app-routing.module';
import { MaterialModule } from '../material/material.module';
import { PipesModule } from '../utilities/pipes/pipes.module';

import { PostsComponent } from './posts.component';
import { PostDetailComponent } from './post-detail/post-detail.component';
import { PostsListComponent } from './posts-list/posts-list.component';
import { PostsService } from './shared/services/posts.service';

@NgModule({
  imports: [
    AppRoutingModule,
    CommonModule,
    HttpClientModule,
    MaterialModule,
    PipesModule
  ],
  declarations: [
    PostsComponent,
    PostDetailComponent,
    PostsListComponent
  ],
  exports: [
    PostsComponent,
    PostDetailComponent,
    PostsListComponent
  ],
  providers: [PostsService]
})
export class PostsModule { }



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/posts/posts.module.ts